document.addEventListener("DOMContentLoaded",function (){
    (function (){
        const megaMenuList = document.querySelectorAll(".yg-mega-menu")

        megaMenuList.forEach(function (megaMenu){
            const collectionList = megaMenu.querySelectorAll('.yg-menu-hover')
            const collectionContentList = megaMenu.querySelectorAll('.yg-menu-content')
            itemMouseenter(collectionList,collectionContentList)
        })

        function itemMouseenter(collectionList,collectionContentList) {
            collectionList.forEach(function (collection,index){
                collection.addEventListener("mouseenter",function (){
                    collectionList.forEach(function (collection){
                        collection.classList.remove("active")
                    })
                    collection.classList.add("active")

                    collectionContentList.forEach(function (collectionContent){
                        collectionContent.style.display = "none"
                    })
                    collectionContentList[index].style.display = "flex"
                })
            })
        }
    }())
})